'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sectionLayoutTypes = exports.componentTypes = exports.socialMediaTypes = undefined;

var _socialMediaTypes = require('./types/socialMediaTypes');

var _socialMediaTypes2 = _interopRequireDefault(_socialMediaTypes);

var _componentTypes = require('./types/componentTypes');

var _componentTypes2 = _interopRequireDefault(_componentTypes);

var _sectionLayoutTypes = require('./types/sectionLayoutTypes');

var _sectionLayoutTypes2 = _interopRequireDefault(_sectionLayoutTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.socialMediaTypes = _socialMediaTypes2.default;
exports.componentTypes = _componentTypes2.default;
exports.sectionLayoutTypes = _sectionLayoutTypes2.default; /**
                                                            * index.js exposes the desired types in the module.
                                                            */